function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { logger as N } from "../../shared-lib/index.js";
import Xt from "../models/backend-errors.js";
import { getErrorMessage as si } from "./error-utils.js";
var l = {
  Y: function Y(t) {
    var e, o;

    try {
      var r = function r() {
        N.error("This browser does not have any supported ajax options!");
      };

      var n = !1;
      if (window.XMLHttpRequest && (n = !0), !n) return void r();
      e = new XMLHttpRequest();

      var s = function s(o) {
        "function" == typeof t.error && t.error(e.status), "function" == typeof t.nt && t.nt(!1, o);
      };

      e.onload = function () {
        var o = !1;
        if (4 !== e.readyState) return;
        o = e.status >= 200 && e.status < 300 || 304 === e.status;
        var r = e.getAllResponseHeaders();

        if (o) {
          if ("function" == typeof t.tt) {
            var _o;

            try {
              _o = JSON.parse(e.responseText);
            } catch (o) {
              var _n = {
                error: "" === e.responseText ? Xt.bu : Xt.Au,
                response: e.responseText
              };
              (0, t.tt)(_n, r);
            }

            _o && t.tt(_o, r);
          }

          "function" == typeof t.nt && t.nt(!0, r);
        } else s(r);
      }, e.onerror = function () {
        s(e.getAllResponseHeaders());
      }, e.ontimeout = function () {
        s();
      }, o = JSON.stringify(t.data), e.open("POST", t.url, !0), e.setRequestHeader("Content-type", "application/json"), e.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      var i = t.headers || [];

      var _iterator = _createForOfIteratorHelper(i),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          e.setRequestHeader(_t[0], _t[1]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      e.send(o);
    } catch (t) {
      N.error("Network request error: ".concat(si(t)));
    }
  }
};
export var readResponseHeaders = function readResponseHeaders(t) {
  var e = {},
      o = t.toString().split("\r\n");
  if (!o) return e;
  var r, n;

  var _iterator2 = _createForOfIteratorHelper(o),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t2 = _step2.value;
      _t2 && (r = _t2.slice(0, _t2.indexOf(":")).toLowerCase().trim(), n = _t2.slice(_t2.indexOf(":") + 1).trim(), e[r] = n);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return e;
};
export default l;